import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { useI18n } from '@/lib/i18n';
import { type RulesSearch, RulesSearchSchema, RulesWorkspacePage } from '@/routes/rules';

export const Route = createFileRoute('/customer-orders/rules')({
  validateSearch: (search) => RulesSearchSchema.parse(search),
  component: CustomerOrderRulesPage,
});

function CustomerOrderRulesPage() {
  const { t } = useI18n();
  const navigate = useNavigate({ from: Route.fullPath });
  const search = Route.useSearch();

  return (
    <RulesWorkspacePage
      search={search}
      copy={{
        sectionLabel: t('customerOrderRules.sectionLabel'),
        pageTitle: t('customerOrderRules.pageTitle'),
        pageDescription: t('customerOrderRules.pageDescription'),
      }}
      onSearchChange={(updater, replace = false) => {
        void navigate({
          replace,
          search: (prev) => updater(prev as RulesSearch),
        });
      }}
    />
  );
}
